import moment from 'moment';
import TruncatedCell from '../../components/Core/TruncatedCell';

const statusBadges: any = {
  PENDDING: { label: 'REQUESTED', color: '#d4d110' },
  REPPROVE: { label: 'DENIED', color: '#d43710' },
  CANCELED: { label: 'CANCELED', color: '#FF7B00' },
  APPROVE: { label: 'APPROVED', color: '#08b408' },
  ACCRUAL: { label: 'ACCRUAL', color: 'rgb(8, 88, 180)' },
  'ANNUAL RESET': { label: 'ANNUAL RESET', color: 'rgb(8, 88, 180)' },
  BONUS: { label: 'BONUS', color: 'rgb(8, 88, 180)' },
};

const collumns = () => {
  const getChange = (row: any) => {
    if (row.status === 'ANNUAL RESET') return '---';
    if (row.hours === 0) return 0;
    if (['ACCRUAL', 'BONUS'].includes(row.status)) {
      return (row.hours > 0 ? '+' : '') + row.hours;
    }
    return '-' + row.hours;
  };

  const getDates = (row: any) => {
    return (
      <>
        {moment(row.startDate).utc().format('MM/DD/YYYY')}
        {row.startDate !== row.endDate ? <> ~ {moment(row.endDate).utc().format('MM/DD/YYYY')}</> : ''}
      </>
    );
  };
  return [
    {
      name: 'Posted',
      grow: 1,
      sortable: true,
      sortField: 'createdAt',
      cell: (row: any) => (
        <>
          {moment(row.createdAt).utc().format('MMMM')}
          <br /> {moment(row.createdAt).utc().format('D, Y')}
        </>
      ),
    },
    {
      name: 'Status',
      grow: 2,
      cell: (row: any) => {
        const badge = statusBadges[row.status];
        if (!badge) return null;
        return (
          <div
            style={{
              display: 'inline-block',
              border: `1px solid ${badge.color}`,
              color: badge.color,
              padding: '4px 8px',
              borderRadius: '3px',
              fontWeight: 700,
              whiteSpace: 'nowrap',
            }}
          >
            {badge.label}
          </div>
        );
      },
    },
    {
      name: 'Dates',
      grow: 2,
      sortable: true,
      sortField: 'startDate',
      cell: (row: any) => getDates(row),
    },
    {
      name: 'Reason',
      grow: 1,
      cell: (row: any) => <TruncatedCell text={row?.describe} maxLength={30} />,
    },
    {
      name: 'Type',
      grow: 1,
      cell: (row: any) => row.reason,
    },
    {
      name: 'Change',
      grow: 1,
      cell: (row: any) => getChange(row),
    },
    {
      name: 'Balance',
      grow: 1,
      cell: (row: any) => row.balance || 0,
    },
  ];
};

export default collumns;
